import * as Location from 'expo-location';

import { fromPromise } from 'xstate';

import type { BackgroundLocationPermissionStatus } from '../../permissions.machine.types';

// ─────────────────────────────────────────────────────────────────────────────

export const getBackgroundLocationPermissionStatusActor =
  fromPromise<BackgroundLocationPermissionStatus>(async () => {
    const [foreground, background] = await Promise.all([
      Location.getForegroundPermissionsAsync(),
      Location.getBackgroundPermissionsAsync(),
    ]);

    return { foreground, background };
  });
